import { i18n } from '@popety_io/popety-io-lib'

const getScoreConfidence = (landIndice?: string) => {
  if (
    landIndice === 'ibus' ||
    landIndice === 'ius' ||
    landIndice === 'cos' ||
    landIndice === 'cus' ||
    landIndice === 'ios' ||
    landIndice === 'im'
  ) {
    return 3
  }

  if (
    landIndice === 'ibus_estimate' ||
    landIndice === 'ius_estimate' ||
    landIndice === 'cos_estimate' ||
    landIndice === 'cus_estimate' ||
    landIndice === 'ios_estimate' ||
    landIndice === 'im_estimate'
  ) {
    return 2
  }

  if (
    landIndice === 'ibus_overide' ||
    landIndice === 'ius_overide' ||
    landIndice === 'cos_overide' ||
    landIndice === 'cus_overide' ||
    landIndice === 'ios_overide' ||
    landIndice === 'im_overide'
  ) {
    return 0
  }

  return 1
}

const getScoreConfidenceData = (landIndice?: string) => ({
  value: getScoreConfidence(landIndice),
  data: [
    {
      color: 'rgba(127, 188, 83, 0.7)',
      value: 3,
      text: i18n.t('common.score.bullet.green'),
      fillCount: 3,
    },
    {
      color: 'rgb(251, 190, 100)',
      value: 2,
      text: i18n.t('common.score.bullet.orange'),
      fillCount: 2,
    },
    {
      color: 'rgba(177, 73, 69, 0.7)',
      value: 1,
      text: i18n.t('common.score.bullet.red'),
      fillCount: 1,
    },
  ],
})

const getRddfLandLink = (land: any, regionRdppfLink?: string) => {
  if (!regionRdppfLink) return

  const find = regionRdppfLink?.search('{egrid_nb}')

  return find
    ? regionRdppfLink?.replace('{egrid_nb}', land?.egrid_nb)
    : regionRdppfLink
        ?.replace('{city_ofs_number}', land.city_ofs_number)
        ?.replace('{code_number}', land.code_number)
}

export { getScoreConfidenceData, getRddfLandLink }
